import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/outline";
import { BasicTooltip } from "../../Tooltip";

export const getBooleanColors = (value: boolean) =>
  value
    ? "bg-green-100 group-hover:bg-green-200 border-green-200 group-hover:border-green-300"
    : "bg-red-100 group-hover:bg-red-200 border-red-200 group-hover:border-red-300";

export const BooleanIcon = ({ value }: { value: boolean }) =>
  value ? (
    <CheckCircleIcon className="h-5 w-5 text-green-600" />
  ) : (
    <XCircleIcon className="h-5 w-5 text-red-600" />
  );

export const BooleanCell = ({
  value,
  className = "",
  tooltipContent,
}: {
  value: boolean;
  className?: string;
  tooltipContent?: string;
}) => {
  return (
    <span
      className={`absolute inset-0 flex items-center justify-center ${className}`}
    >
      {tooltipContent ? (
        <BasicTooltip offset={-100} side="top" content={tooltipContent}>
          <span className="flex h-full w-full items-center justify-center">
            <BooleanIcon value={value} />
          </span>
        </BasicTooltip>
      ) : (
        <BooleanIcon value={value} />
      )}
    </span>
  );
};
